import React from "react";
import "./styles.css";

interface LButtonProps {
  label?: string;
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
  className?: string;
  style?: React.CSSProperties;
  disabled?: boolean;
  icon?: React.ReactNode;
  iconPosition?: "left" | "right";
  color?:
    | "primary"
    | "orange"
    | "danger"
    | "transparent"
    | "success"
    | "light"
    | "gray";
  textColor?:
    | "primary"
    | "orange"
    | "danger"
    | "white"
    | "black"
    | "gray"
    | "light";
  tooltip?: string;
  size?: "sm" | "md" | "lg";
  children?: React.ReactNode;
}

const LButton: React.FC<LButtonProps> = ({
  label,
  onClick,
  type = "button",
  className = "",
  style = {},
  disabled = false,
  icon,
  color = "primary",
  textColor = "white",
  iconPosition = "left",
  tooltip,
  size = "md",
  children,
}) => {
  const resolvedTextColor = disabled ? "secondary" : textColor;
  const sizeClass = {
    sm: "btn-sm",
    md: "btn-md",
    lg: "btn-lg",
  }[size];

  return (
    <div
      className="tooltip-container"
      style={{ position: "relative", display: "inline-block" }}
      title={disabled && tooltip ? tooltip : undefined}
    >
      <button
        type={type}
        className={`site-button ${color === "primary" ? "site-button-primary" : ""} btn btn-${color} ${sizeClass} w-100 d-flex gap-2 justify-content-center align-items-center px-3 text-${resolvedTextColor} ${className}`}
        style={{ fontWeight: "700", ...style }}
        onClick={onClick}
        disabled={disabled}
      >
        {icon && iconPosition === "left" && (
          <span className={`text-${resolvedTextColor}`}>{icon}</span>
        )}
        {label ? <span>{label}</span> : children}
        {icon && iconPosition === "right" && (
          <span className={`text-${resolvedTextColor}`}>{icon}</span>
        )}
      </button>
    </div>
  );
};

export default LButton;
